// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  margin-bottom: 0;
  padding-bottom: 0;
  color: #111111;
}

.name {
  font-size: 1.4rem;
  margin: 0;
  padding: 0;
}

.fullView-wrapper.stretched {
  padding-left: 0;
  padding-right: 0;
}

.informationPanel {
  padding-left: 17px;
  padding-right: 17px;
}

.padding17 {
  padding: 17px 17px 0 17px;
}

.withIcon .mat-icon-button {
  position: absolute;
  right: 17px;
  margin-top: -24px;
  z-index: 100;
}

.withIcon .mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 14px;
}

.withIcon h2 {
  position: absolute;
}

.records {
  width: 100%;
  table-layout: fixed;
  min-height: 95px;
}

.truncate {
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.viewTab {
  padding-top: 10px;
}

.outlineOverlay {
  position: absolute;
  top: 45%;
  left: 0;
  width: 100%;
  height: 55%;
  background-color: white;
  opacity: 0.65;
}

.noneTitle {
  position: absolute;
  top: 70%;
  left: 0;
  width: 100%;
  font-size: 4rem;
  text-align: center;
  color: #111111;
}

::ng-deep .justifyRight .mat-grid-tile .mat-figure {
  justify-content: flex-end;
}

::ng-deep .withIcon .mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]), ::ng-deep .withIcon .mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]), ::ng-deep .withIcon .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]) {
  background: transparent;
}

::ng-deep .withIcon .mat-expansion-panel-header {
  width: 0;
}

::ng-deep .withIcon .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}

::ng-deep .withIcon .mat-expansion-panel-header {
  padding: 0;
}

::ng-deep .withIcon .mat-expansion-panel-header-description,
::ng-deep .withIcon .mat-expansion-panel-header-title {
  margin: 0;
  font-size: 1.2rem;
}

::ng-deep .withIcon .mat-expansion-indicator,
::ng-deep .withIcon .mat-expansion-panel-header.mat-expanded .mat-icon-button,
::ng-deep .withIcon .mat-expansion-panel-header.mat-expanded .mat-icon {
  display: none;
}

::ng-deep .withIcon .mat-content {
  max-width: 107px;
}

::ng-deep .withIcon .mat-expansion-panel-body {
  border: 1px #bcbcbc solid;
  padding-top: 10px;
  font-size: 1.3rem;
}

::ng-deep .withIcon .mat-expansion-panel-body h3 {
  font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/idw-matrices/components/mobile/mobile-idw-matrix-report/mobile-idw-matrix-report.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAMQ;EACI,uBAAA;AAHZ;;AAQA;EACI,QAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,UAAA;AALJ;;AAQA;;EAEI,SAAA;EACA,iBAAA;AALJ;;AAQA;;;EAGI,aAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,yBAAA;EACA,iBAAA;EACA,iBAAA;AALJ;;AAQA;EACI,iBAAA;AALJ","sourcesContent":["h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    color: #111111;\n}\n\n.name {\n    font-size: 1.4rem;\n    margin: 0;\n    padding: 0;\n}\n\n.fullView-wrapper.stretched {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.informationPanel {\n    padding-left: 17px;\n    padding-right: 17px;\n}\n\n.padding17 {\n    padding: 17px 17px 0 17px;\n}\n\n.withIcon .mat-icon-button {\n    position: absolute;\n    right: 17px;\n    margin-top: -24px;\n    z-index: 100;\n}\n\n.withIcon .mat-icon {\n    font-size: 17px;\n    width: 17px;\n    height: 17px;\n    line-height: 14px;\n}\n\n.withIcon h2 {\n    position: absolute;\n}\n\n.records {\n    width: 100%;\n    table-layout: fixed;\n    min-height: 95px;\n}\n\n.truncate {\n    width: 80%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.viewTab {\n    padding-top: 10px;\n}\n\n.outlineOverlay {\n    position: absolute;\n    top: 45%;\n    left: 0;\n    width: 100%;\n    height: 55%;\n    background-color: white;\n    opacity: 0.65;\n}\n\n.noneTitle {\n    position: absolute;\n    top: 70%;\n    left: 0;\n    width: 100%;\n    font-size: 4rem;\n    text-align: center;\n    color: #111111;\n}\n\n::ng-deep .justifyRight .mat-grid-tile .mat-figure {\n    justify-content: flex-end;\n}\n\n::ng-deep .withIcon .mat-expansion-panel {\n    & .mat-expansion-panel-header.cdk-keyboard-focused,\n    & .mat-expansion-panel-header.cdk-program-focused,\n    &:not(.mat-expanded) .mat-expansion-panel-header:hover {\n        &:not([aria-disabled='true']) {\n            background: transparent;\n        }\n    }\n}\n\n::ng-deep .withIcon .mat-expansion-panel-header {\n    width: 0;\n}\n\n::ng-deep .withIcon .mat-expansion-panel:not([class*=mat-elevation-z]) {\n    box-shadow: none;\n}\n\n::ng-deep .withIcon .mat-expansion-panel-header {\n    padding: 0;\n}\n\n::ng-deep .withIcon .mat-expansion-panel-header-description,\n::ng-deep .withIcon .mat-expansion-panel-header-title {\n    margin: 0;\n    font-size: 1.2rem;\n}\n\n::ng-deep .withIcon .mat-expansion-indicator,\n::ng-deep .withIcon .mat-expansion-panel-header.mat-expanded .mat-icon-button,\n::ng-deep .withIcon .mat-expansion-panel-header.mat-expanded .mat-icon {\n    display: none;\n}\n\n::ng-deep .withIcon .mat-content {\n    max-width: 107px;\n}\n\n::ng-deep .withIcon .mat-expansion-panel-body {\n    border: 1px #bcbcbc solid;\n    padding-top: 10px;\n    font-size: 1.3rem;\n}\n\n::ng-deep .withIcon .mat-expansion-panel-body h3 {\n    font-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
